import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('user');
  const [token, setToken] = useState('');

  const login = (email, password, role) => {
    setIsLoggedIn(true);
    setUserName(email.split('@')[0]);
    setUserRole(role);
    setToken(`token_${email}_${Date.now()}`);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserName('');
    setUserRole('user');
    setToken('');
  };

  return (
    <AuthContext.Provider value={{
      isLoggedIn,
      userName,
      userRole,
      token,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};